import { render, staticRenderFns } from "./AppDisplay.vue?vue&type=template&id=07f4e1fa&scoped=true&lang=pug&"
import script from "./AppDisplay.vue?vue&type=script&lang=js&"
export * from "./AppDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AppDisplay.vue?vue&type=style&index=0&id=07f4e1fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4e1fa",
  null
  
)

export default component.exports